import React from 'react'
import PropTypes from 'prop-types'
import { Tonality } from '@dsny/dsny-component-library'
import { Musicnote } from '@dsny/dsny-component-library/icons'
import { useTheme } from 'styled-components'
import { NoResultsWrap, IconWrapper, IconCircle } from '../Search.styles'

function NoResults({ title, tip }) {
  const theme = useTheme()
  return (
    <NoResultsWrap data-cy="search-no-results">
      <IconWrapper>
        <IconCircle>
          <Musicnote color={theme.colors.player40} width={32} height={32} />
        </IconCircle>
      </IconWrapper>
      <Tonality.UIHeading
        headingStyle="headline5"
        style={{
          fontSize: 28,
          marginBottom: 8,
          textAlign: 'center',
          lineHeight: '38px'
        }}
        color={theme.colors.neutralW90}
      >
        {title}
      </Tonality.UIHeading>
      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW70}
        style={{ textAlign: 'center' }}
      >
        {tip}
      </Tonality.UIText>
    </NoResultsWrap>
  )
}

NoResults.propTypes = {
  title: PropTypes.node.isRequired,
  tip: PropTypes.node
}

export default NoResults
